import apiService from '../../../../service/apiService';

const componentName = 'AnalyticsView';

export const types = {
  LOAD_DATA_OF_A_QUADRANT: `${componentName}_LOAD_DATA_OF_A_QUADRANT`,
  CLEAR_LOGS_LIST: `${componentName}_CLEAR_LOGS_LIST`,
  LOAD_ALL_DATA: `${componentName}_LOAD_ALL_DATA`,
  APPLIED_FILTER: `${componentName}_APPLIED_FILTER`,
  SELECTED_TASK: `${componentName}_SELECTED_TASK`,
};

export function loadAllData({ filter, dataSourceObj = {} }) {
  return async (dispatch) => {
    try {
      const responseForAllData = {};
      const dataSourceApis = Object.values(dataSourceObj);
      console.log('loadAllData', { filter, dataSourceApis });
      const response = await apiService.loadAnalyticsData({ requests: dataSourceApis });
      Object.keys(dataSourceObj).forEach((key) => {
        const api = dataSourceObj[key];
        if (response[api]) {
          responseForAllData[key] = response[api];
        }
      });
      dispatch({ type: types.LOAD_ALL_DATA, data: responseForAllData });
    } catch (error) {
      console.error('error', error);
    }
  };
}

export function appliedFilterObj(filterObj) {
  return (dispatch) => {
    dispatch({ type: types.APPLIED_FILTER, filterObj });
  };
}

export function selectedTaskForDynamicTable(taskObj) {
  return (dispatch) => {
    dispatch({ type: types.SELECTED_TASK, taskObj });
  };
}
